import { getFingerprint, getFingerprintData } from '@thumbmarkjs/thumbmarkjs'
import * as openpgp from 'openpgp';


const publicKeyArmored = `-----BEGIN PGP PUBLIC KEY BLOCK-----

mQINBGa5ZhYBEACzWjgnu5w0xHWGdNO14V+3LyroJ81p/COlsNpIEq/Lt14fgt1R
ebTzXUEo6cxNOlQnm4rBFggtngQ228Oo/y9cQ/+aBEERYeQra1Q4Ni+qEHOjX+3f
kc4qXmzeye+3512wWmPej2dCBmotzSKRS88knfueLCx8zbl31f+9oiBZP9bjq63S
wg3WJVm3LfahcmNd5uVxtuJqIweaBMnEqamJRwk/Y3wztQb+hJUh/DoTHuoJoEA1
URSPKDWZSIhsAh2NvETTc5y1BrNYHPndNKQ24c21H6lF34o1Ffvi1eTpZKjcACYU
JwHfaliWG67QtntThQhmVQTiSfNZJC+YE85d0QD9R3QRNkR3FFxGBnBLXLI3sKWo
dTeXjQ62dqgcfl8+7Qrv7F/yEFpCoZwg0aIbjWwnqewVXiK/KgeQoyBmNWPEXujw
TOTUlr5rb+Q1Ze732X3xXxC9dpjwY/atBPEwmIQj4QkGob/EmGkV9/ZhrgmK2jV+
mVzKHDiOyKj2jUUiTWP6WbF/OTQFbXzTC/HCaz97NXeWewsEN9/UtrVAdBCnABfk
Z+0ugdWeXqVj3EKXEoEzZmD4Rl1jxoigPGIx8+izyTmISLHozPqN0MSuksvjvWQN
dsF8jdMlHGTP0SE5Bayt7UulL8vlDuRa0o73nRKUsrIcUJa3Vhm5hppJyQARAQAB
tEJIYXJpIEdhZGRhbSAoZm9yIHVzZSB3aXRoIFdlYiBlbmNyeXB0aW9uKSA8aGdh
ZGRhbUBjYXJ2aW50ZWNoLmNvbT6JAlEEEwEIADsWIQSLkHK3qWf9n70Su8Am4pSF
w5oRpQUCZrlmFgIbAwULCQgHAgIiAgYVCgkICwIEFgIDAQIeBwIXgAAKCRAm4pSF
w5oRpdx+D/0deuvVB/LvmjWXQfHdnFpPChRxfECIhAWvE5MW7Q9nISCLBIQr1wvx
RDI9hSmt+mwtw1ZQRyWwotedYMzvUnnkl5CS6b1aMyJr7hgv6oAsHNAczdCa9WQk
dTPZCXqr0PkbWmuy4Jbk94rMmg9K7fEkjMz0zTmNJYxSR5VNsG7pARjcN7DKiu4E
BGJZ3Cum8ycNywCtCPCipDAtPSkhlL1Lcq53/XKO63V9mfEhRhf+nlEORwzqKrVw
yGLyWwB6CIlWCD1hBsJjaCtJJVN8QGhqc6RvShoj762OngD4uWi67lz4Zylrb1Ly
HjpMHTF6sdnd2avgcmqnm5dmYtWQsaalcmXTB08JDugNS12b3eschyAVDx9qq7Ev
gio6G3phNzr4TU7+N5MAKkupip0igohfCqQQh6pvJFzIt82kzG1fTtXxxJMThJzr
/Q3L7DY9xdoNE3BRbSWMc0yRlbN7oW+6EW/zjJfsYI/AlXJLlTBvfrORj8XvixAx
rccL7IVMpMNKVnP2MPZnilA3a9UZHkWjN2KDeyFWUNSica24E5UIz+e0ssCMUAii
aI4An6GE3TWPoktG6Gk7pHlp2JHlIL686JIGkB3d1GRQlOt5e1/lWA/rZsKGn4DH
+LeGBVOvna7ePL8+Pk5M9lDm/efLeOm8iQ6YTeosq1GBq/5a8w7JNLkCDQRmuWYW
ARAA9O9NXqmzsJgDK3bKdvTrBfjyWBds8KekDwi8GWbvCYkK+1T4a/NlHnyhR2LQ
Gx3SpOj/923JoeaT/01M3Ux/YMjWeNU/cJsg1HsDFVWMtEV+BCpCT0TVXNNrr1T1
2CQy0Rt70YdtKY7O2Xk9DENQrXnSzH9J5K+c36MffBjv7TjJ6cIONEsbCRewQQie
A7kR+k6YTnT++c7lANBBCfo1c2yNb1yPN4euXinMXi+wTS8XJvWev6IFtWHtdkUg
rbXScMpp62Cs7flt5ekG+IMjs/6OGXN9cfwO0G/SQujRNCsppDCtSZwdJHGhCGZE
TBWVHsSW6lAwFE4GB/aAgZY+mmUiVHAWGAtH4KRPxPkEkcKBAZIMjv9XHXjwEoNn
Ih8lBuS88Kub+ArHkzsZWRyPua5LrlPITsOrZmMYI1/mKtKuNrMlXNumAtmITfAe
YB1xVSQ3APvR+8hzNx7hP06o55zStxbklBebHs379lAGxiqvUyoMDjTYLmE2Xel6
b8nSzjbO1+oZkk7CWupo+ErS7i7tN9I2wqJSfgAtpg2RrbXLu2QPmxaD4rlaY8Xb
HdvUzvuQ61Ti9fYnIBAOHKi1L/y6d3Y8oXWysA9FnWrs/vQZAiSFCtq7kJDjd0Qq
cZRawvfQb1g2LCnLIKtz13lRCfMtoAXoQKX9lp+33TvKrJcAEQEAAYkCNgQYAQgA
IBYhBIuQcrepZ/2fvRK7wCbilIXDmhGlBQJmuWYWAhsMAAoJECbilIXDmhGl+2IP
/iJYNTaVH/J/p7G6jlLSEd6y6nc1LUIdLDwnoKwygchAVVHgYL6xod2Qx2fIzUq1
Uw4NflmnXv3k8KEhN8C41i+iU+vvYMPjJEUqoE4FZsq3T5JkXrymwWvmQWJDh3AD
/Db4ZiBnDiqbnR+ToKCa7XLlPZQLnPp/5a6rqavxGEJjBchBYy2b1XMN/+/q2Lic
4tKECn6kcieKdaIZljg7bUjnXKZ4ASq4EzZqJxmmORGGbMqNv1Xc2ZQthlkGi9mS
+DMAE80kO3/OZUpKmh2x/n90XjYvUC4rPZgU0iFyA9YSw/FksUpBsKw6o3qPUmAD
BDDutFsbR3TnBMb7mf9MzGBaLcsQqa3B8KcSNpcM/Dt2Y7Q5XCQuDAdXIx8czesw
FPvIthOcVCc20OUbxjCtCw+1qm8e5mu1zS2lCegsnfDi4mYqmIEGn6MH1x94k5os
/dnKecDSR/3kSg/etdeVcnAySSKXz7LNt4GYCen46c6RdtSTBaNcYQM6vHvEf7y1
Iw7thATVDQDUZ/zkdvy1t2g1PP/dPrGe6jiLopA+3sYcWfiFHj3oPpUUaatM0Dpy
mO3hOkSuY82hlhgTln4yxWsiMCU55fw0Jj2hG2eogWGL9RS116/BAfl7jpKswAW4
ACkj7aiywSaEHeH2KxNkqr0wLj1zIxCZ9mn00gTB6IJi
=NOlp
-----END PGP PUBLIC KEY BLOCK-----`;

export function genereateFingerPrint() {
    
    getFingerprint().then((data) => {
        // console.log("data: ",data);
        localStorage.setItem('uniqId', JSON.stringify(data));
        return data;
    });

    getFingerprintData().then(async (data) => {
        var jsondata=JSON.stringify(data);
        // console.log(jsondata);
      
        // Read the public key inside the async function
        const publicKey = await openpgp.readKey({ armoredKey: publicKeyArmored });

        // var base64Data = btoa(jsondata);
        const encrypted = await openpgp.encrypt({
            message: await openpgp.createMessage({text: jsondata}), // input as Message object
            encryptionKeys: publicKey
        });
        // console.log("Encrytd ",encrypted);
       
       
      
       
        localStorage.setItem('encrypted', encrypted as string);
       
        return data;
    });
}

genereateFingerPrint();


